import GeomTool from '../geom/GeomTool';
import MathTool from '../math/MathTool';

/*
options: {
    speed: function
    pressure: function
    tilt: function
    rotation: function
}
*/
export class Gesture{
    constructor( points, options ){
        this.points = points;
        this.options = options;
    }
}



export class Brush{
    /**
     * 
     * @param {String} color 
     * @param {Number} size 
     * @param {Number} bristleSize 
     * @param {Number} randLong 
     * @param {Number} randPerp 
     * @param {Number} randRadius 
     * @param {Number} randAngle 
     */
    constructor( color, size, bristleSize=10, randLong=0, randPerp=0, randRadius=0, randAngle=0 ){
        this.color = color;
        this.size = size;
        this.bristleSize = bristleSize;
        this.randLong = randLong;
        this.randPerp = randPerp;
        this.randRadius = randRadius;
        this.randAngle = randAngle;        
    }

    drawGesture( gesture ){
        for( let i = 0; i < gesture.points.length; i++ ){
            let point = gesture.points[i];
            let nextPoint = gesture.points[i+1];

            let pressure = gesture.options && gesture.options.pressure ? gesture.options.pressure(point, i) : 1;
            let rotation = gesture.options && gesture.options.rotation ? gesture.options.rotation(point, i) : 0;
            
            let angle = 0;

            // Final renderable point, having applied transforms
            let finalPoint = {...point};
            let finalNextPoint;
            if( nextPoint ){
                finalNextPoint = {...nextPoint};
            }

            if( this.randLong){
                finalPoint.x += MathTool.random()*this.randLong-(this.randLong)*.5;
                if( nextPoint ){
                    finalNextPoint.x += MathTool.random()*this.randLong-(this.randLong)*.5;
                }
            }
            if( this.randPerp){
                finalPoint.y += MathTool.random()*this.randPerp-(this.randPerp)*.5;
                if( nextPoint ){
                    finalNextPoint.y += MathTool.random()*this.randPerp-(this.randPerp)*.5;
                }
            }  
            if( this.randRadius){
                finalPoint.x += MathTool.random()*this.randRadius;
                if( nextPoint ){
                    finalNextPoint.x += MathTool.random()*this.randRadius;
                }
            }
            if( this.randAngle){
                finalPoint.y += MathTool.random()*this.randAngle;
                if( nextPoint ){
                    finalNextPoint.y += MathTool.random()*this.randAngle;
                }
            }
            
            if( nextPoint ){
                angle = Math.atan2(finalNextPoint.y - finalPoint.y, finalNextPoint.x - finalPoint.x) + Math.PI*.5;
            }

            // Drawing
            p5App.push();
            p5App.translate(finalPoint.x, finalPoint.y);
            p5App.rotate(angle);
            p5App.scale(pressure);
            //p5App.noStroke();
            //p5App.fill( this.color );
            p5App.stroke( this.color );
            p5App.strokeWeight( this.bristleSize );
            let brushSize = this.size;
            p5App.line( -brushSize*.5*pressure, 0, brushSize*.5*pressure, 0 );
            //p5App.ellipse(0, 0, brushSize, brushSize );
            p5App.pop();       
        }
    }

    drawPoint(index, gesture){
        // gesture props
        
    }
}

export class BeadsBrush{
    /**
     * 
     * @param {String} color 
     * @param {Number} brushLength 
     * @param {Number} brushWidth 
     * @param {Number} strokeWeight 
     * @param {Number} randLong 
     * @param {Number} randPerp 
     * @param {Number} randRadius 
     * @param {String} shape
     */
    constructor( options ){
        // Set default options
        this.brushLength = 5;
        this.brushWidth = 5;
        this.strokeWeight = 1;
        this.randLong = 0;
        this.randPerp = 0;
        this.randRadius = 0;     
        this.shape = "circle";     
        this.fillColor = "#000000";
        this.strokeColor = "#000000";
        this.pathStrokeColor = "#000000";
        this.pathStrokeWeight = 2;
        this.rotationMode = "none"; // none, path

        // color, brushLength, brushWidth, strokeWeight=10, randLong=0, randPerp=0, randRadius=0, shape="circle"
        // oerride with user-provided options
        for( let p in options ){
            this[p] = options[p]
        }
    }

    //getOptionValue( optionName, )

    drawGesture( gesture ){
        // duplicate points since they might be modified
        let gesturePointsCopy = gesture.points.map( point => {
            return {...point};
        } );

        // Apply randomness to path points
        for( let i = 0; i < gesturePointsCopy.length; i++ ){
            let point = gesturePointsCopy[i];
            if( this.randLong){
                point.x += MathTool.random()*this.randLong-(this.randLong)*.5;
            }
            if( this.randPerp){
                point.y += MathTool.random()*this.randPerp-(this.randPerp)*.5;
            }  
            if( this.randRadius){
                let finalPoint = GeomTool.randomPointInCircle( this.randRadius, point.x, point.y )
                point.x = finalPoint.x;
                point.y = finalPoint.y;
            }
        }
        
        let angle;

        // Iterate over path points
        for( let i = 0; i < gesturePointsCopy.length; i++ ){
            let point = gesturePointsCopy[i];
            let nextPoint = gesturePointsCopy[i+1];            

            let pressure = gesture.options && gesture.options.pressure ? gesture.options.pressure(point, i) : 1;
            let rotation = gesture.options && gesture.options.rotation ? gesture.options.rotation(point, i) : 0;
            
            // set angle
            if( this.rotationMode == "path" ){
                if( nextPoint ){
                    angle = Math.atan2(nextPoint.y - point.y, nextPoint.x - point.x) + Math.PI*.5;
                }
                // Else, keep previous point angle
            }else{
                angle = 0;
            }

            // Draw backbone line
            if( this.pathStrokeColor != null  && this.pathStrokeWeight > 0  && nextPoint ){
                p5App.push();

                p5App.noFill();
                p5App.stroke( this.pathStrokeColor );
                p5App.strokeWeight( this.pathStrokeWeight );
                p5App.line( point.x, point.y, nextPoint.x, nextPoint.y );
                
                p5App.pop();
            }

            // Draw shape
            p5App.push();

                p5App.noStroke();
                p5App.noFill();
                
                // Set fill
                if( this.fillColor != null ){
                    p5App.fill( this.fillColor );                
                }
                // Set stroke
                if( this.strokeColor != null && this.strokeWeight > 0 ){
                    p5App.stroke( this.strokeColor );
                    p5App.strokeWeight( this.strokeWeight );
                }

                // Move brush tip
                p5App.translate(point.x, point.y);
                p5App.rotate(angle);
                /* 
                p5App.scale(pressure); */
                //p5App.line( -brushSize*.5*pressure, 0, brushSize*.5*pressure, 0 );
                p5App.rectMode(p5App.CENTER);
                /* p5App.noStroke();
                p5App.fill( this.color ); */
                if( this.shape == "rect"){
                    p5App.rect(0, 0, this.brushWidth*pressure, this.brushLength*pressure  );                
                }
                else if( this.shape == "circle"){
                    p5App.ellipse(0, 0, this.brushLength, this.brushWidth );
                }
                //p5App.ellipse( 0, 0, this.brushWidth, this.brushLength );
            



            p5App.pop();   
        }
    }

    drawPoint(index, gesture){
        // gesture props
        
    }
}

